module.exports = __webpack_public_path__ + "static/media/contact.ad23be63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/menu/contact.jpg
// module id = 149
// module chunks = 0